import { useEffect } from 'react';
import { useRouter } from 'next/router';

/**
 * A hook that is useful for when you want to do something when the user navigates
 * with a shallow route.
 *
 * For example:
 * You are on: /news?page=2 and navigate to /news?page=1 => shallow navigation => triggered
 * You are on: /news?page=2 and navigate to /news-overview => deep navigation => not triggered
 */
export function useBeforeShallowRouteStart(callback: (targetUrl: string) => void) {
	const router = useRouter();

	useEffect(() => {
		const handleRouteChange = (url: string, opts: { shallow: boolean }) => {
			if (opts.shallow) {
				callback(url);
			}
		};

		router.events.on('routeChangeStart', handleRouteChange);

		// If the component is unmounted, unsubscribe
		// from the event with the `off` method:
		return () => {
			router.events.off('routeChangeStart', handleRouteChange);
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps -- only run on mount
	}, []);
}
